export const siteInfo = {
  name: '韩漫导航',
  tagline: '韩漫漫画网址导航汇总',
  description: '汇集韩漫网站、韩漫网、韩漫之家与韩漫屋等热门平台入口，提供免费韩漫漫画网址导航与在线观看汇总，方便漫迷集中浏览与收藏。',
  url: 'https://hanman.site/',
  email: 'contact@hanman.site',
  foundedYear: '2023',
  stats: {
    platforms: '30+',
    users: '50000+',
    articles: '100+',
    categories: '6',
  },
};